// WhatsApp por Zernio (D73): conexion de la empresa, plantillas aprobadas y envio desde un caso.
import { request } from './http';

export type EstadoWhatsApp = { conectado: boolean; accountId?: string; grupo?: string; motorId?: string | null; webhook?: string; secretoWebhook?: string };
export type Plantilla = { nombre: string; idioma: string; categoria: string; texto: string };

export const estadoWhatsApp = () => request<EstadoWhatsApp>('/mensajeria/api/estado');
export const conectarWhatsApp = (d: { zernioKey: string; accountId: string; grupo: string; llaveMotor: string; motorId: string }) =>
  request<{ conectado: true; webhook: string; secretoWebhook: string }>('/mensajeria/api/conectar', { method: 'POST', body: d });
export const desconectarWhatsApp = () => request('/mensajeria/api/conectar', { method: 'DELETE' });
export const plantillasWhatsApp = () => request<{ plantillas: Plantilla[] }>('/mensajeria/api/plantillas').then((r) => r.plantillas);
export const enviarWhatsApp = (d: { casoId: string; texto?: string; plantilla?: { nombre: string; idioma: string; parametros: string[] } }) =>
  request<{ enviado: boolean }>('/mensajeria/api/enviar', { method: 'POST', body: d });

// Cuantas variables {{1}}, {{2}}… tiene el texto de una plantilla.
export const variablesDe = (texto: string) => new Set([...texto.matchAll(/\{\{\s*(\d+)\s*\}\}/g)].map((m) => m[1])).size;
